<template>
    <div class="panel-body">
        <div v-for="group in channel.items" :key="group.groupingName">
            <div class="row">
                <div class="col-md-12 clearfix">
                    <h3>{{group.groupingName}}</h3>
                </div>
            </div>
            <input-loader :fields="group.groupItems"></input-loader>
        </div>

        <div class="form-group row">
            <div class="col-md-9 ml-auto text-right">
                <button v-on:click="saveBigcommerce()" type="button" class="btn btn-primary">Save</button>
                <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                    Cancel
                </a>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import InputLoader from "../form/form-loader.vue";
    import getNestedProperty from "../../mixins/getNestedProperty.js";
    import addCommonSettings from "./common-settings.js";

    export default {
        name: "bigcommerce-specific",
        components: {
            "input-loader": InputLoader,
        },
        mixins: [getNestedProperty, addCommonSettings],
        props: ['channelvalues', 'channeloptions'],
        data() {
            return {
                channel: {
                    items: [],
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
                baseUrl: base_url,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                loading: false
            };
        },
        methods: {
            saveBigcommerce: function () {
                this.loading = true;
                this.$emit("channel-specific-save", this.channel);
            },
            setItems: function () {
                var cvs = this.channelvalues;
                var cfo = this.channeloptions;

                this.channel.items = [
                    {
                        groupingName: "Settings",
                        groupItems: [
                            {
                                name: "relation_type",
                                label: "Main Product Relation",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                disabled: (cfo.disableRelationType) ? cfo.disableRelationType : false,
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'productRelatedTypeId')) ? cvs.json_options.configuration.productRelatedTypeId  : "",
                                options: (cfo.productRelatedType) ? cfo.productRelatedType : [],
                                tooltip: 'Select which product relation type you wish to use as the “related products” section on the chosen channel',
                                tooltip_position: 'top'
                            },
                            {
                                name: "product_json_warranty",
                                label: "Push json product into warranty field",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'product_json_warranty')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include product description as JSON in the warranty field'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Product description won\'t be included in the warranty field'
                                    }
                                ],
                                tooltip: 'Include the warranty as json in the product description',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name : "product_json_version",
                                label : "Push json product versions into metafields",
                                required : false,
                                type : "select",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'product_json_version')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include the product description versioned as json in the metafields'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - The product description versioned will not be included in the metafields'
                                    }
                                ],
                                tooltip: 'This feature stores the json versions into metafields',
                                tooltip_position: 'top',
                                hide: !cfo.product_json_version_metafield
                            },
                            {
                                name: 'category_json',
                                label: 'Push json category into metafields',
                                required: false,
                                type: 'select',
                                column: 'col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end',
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'category_json')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Include the category as json in the metafields'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - The category will not be included in the metafields'
                                    }
                                ],
                                tooltip: 'Include the category as json in the metafields',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "import_custom_fields",
                                label: "Import Custom Fields",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'import_custom_fields')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Import the custom fields from the store'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Custom fields will not be imported from the store'
                                    }
                                ],
                                tooltip: 'Import the custom fields from the store',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "parent_categories",
                                label: "Push Parent Categories",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'parent_categories')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Push the parent categories of the products synced'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Parent categories will not be pushed to the store'
                                    }
                                ],
                                tooltip: 'Push parent categories of the products synced',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "hide_disabled",
                                label: "Hide Products When Disabled",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'hide_disabled')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Hide all products that aren\'t enabled on the store on sync'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Don\'t change visibility of products that aren\'t enabled on sync'
                                    }
                                ],
                                tooltip: 'Set the visibility of the products that are not enabled on the store on a sync',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "push_child_assets",
                                label: "Push Child Assets Into Parent When No Assets",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'push_child_assets')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Push the Child Assets into Parent when the parent has no assets'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Leave Parent Assets empty - even if a child has assets'
                                    }
                                ],
                                tooltip: 'If product has no assets then attempt to use child assets for it',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "is_weight_required",
                                label: "Use default weight",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'is_weight_required')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - If weight is required and empty use default weight'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Leave weight empty if it is empty - ignore the default weight'
                                    }
                                ],
                                tooltip: 'If weight is required and empty use default weight as the weight',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "default_weight",
                                label: "Default Weight",
                                required: false,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'default_weight')) ? cvs.json_options.configuration.default_weight  : "",
                                tooltip: 'If weight is required and empty use default weight as the weight',
                                tooltip_position: 'top'
                            },
                            {
                                name: "is_price_required",
                                label: "Use default price",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'is_price_required')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - If price is required and empty use default price'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Leave price empty if it is empty - ignore the default price'
                                    }
                                ],
                                tooltip: 'If price is required and empty use default price as the price',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "default_price",
                                label: "Default Price",
                                required: false,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'default_price')) ? cvs.json_options.configuration.default_price  : "",
                                tooltip: 'If price is required and empty use default price as the price',
                                tooltip_position: 'top'
                            },
                            {
                                name: "price_list_records",
                                label: "Enable Price List Records",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'price_list_records')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Allow the use of price lists while setting up products'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Do not use price list records to set product prices'
                                    }
                                ],
                                tooltip: 'Price Lists let you offer advanced variant-level price overrides based on customer groups.',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "currency",
                                label: "Currency (Price Lists Records)",
                                required: false,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'currency')) ? cvs.json_options.configuration.currency  : "",
                                tooltip: 'Default currency used',
                                tooltip_position: 'top'
                            },
                            {
                                name: "sync_all_options",
                                label: "Sync All Options",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'sync_all_options')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Sync ALL options'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Sync only active options'
                                    }
                                ],
                                tooltip: 'Sync all product options (ON) or sync only active options (OFF)',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "child_lowest_price",
                                label: "Push Lowest Child Price For Parent Product",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'child_lowest_price')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Use child product price in place of active price if child price is lower'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Use active price for a product even if child price is lower'
                                    }
                                ],
                                tooltip: 'If any child product has a lower price use that instead of active price',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "import_skip_new_products_from_versions",
                                label: "Import - Skip products from version stores that doesn't exist on master",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'import_skip_new_products_from_versions')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Skip new products from version stores'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Import new products from version stores'
                                    }
                                ],
                                tooltip: 'Skip new products from version stores if this is enabled',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "coupon_processing_enabled",
                                label: "Enable Coupon Processing",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'coupon_processing_enabled')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Coupon Processing is ON'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Coupon Processing is OFF'
                                    }
                                ],
                                hide: !cfo.showSherrillBcSettingsFields,
                                tooltip: 'Enable Coupon Processing',
                                tooltip_position: 'top'
                            },
                            {
                                name: "sync_categories_enabled",
                                label: "Enable Sync Categories",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'sync_categories_enabled')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Product category sync is ON'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Product category sync is OFF'
                                    }
                                ],
                                hide: !cfo.showSherrillBcSettingsFields,
                                tooltip: 'Sync the product categories during the sync',
                                tooltip_position: 'top'
                            },
                            {
                                name: "disable_price_sync",
                                label: "Price Sync",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'disable_price_sync')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'false',
                                        'name' : 'Enabled - Price Sync is ON'
                                    },
                                    {
                                        'id' : 'true',
                                        'name' : 'Disabled - Price Sync is OFF'
                                    }
                                ],
                                tooltip: 'Do not update prices on sync',
                                tooltip_position: 'top-no-label'
                            },
                            {
                                name: "attributes_sync",
                                label: "Attributes Sync",
                                required: false,
                                type: "select",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'attributes_sync')) ? cvs.json_options.configuration.attributes_sync  : "",
                                options: [
                                    { id: "custom_fields", name: "Custom Fields" },
                                    { id: "metafields", name: "Metafields" },
                                    { id: "both", name: "Custom Fields and Metafields" },
                                ],
                                tooltip: 'Sync attributes as the selected option',
                                tooltip_position: 'top'
                            },
                            {
                                name: "bc_metafields_namespace",
                                label: "Metafields Namespace",
                                required: false,
                                type: "text",
                                column: "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                maxlength: "20",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'bc_metafields_namespace')) ? cvs.json_options.configuration.bc_metafields_namespace  : "",
                                tooltip: 'Use this as the Bigcommerce namespace otherwise use the default "jasper"',
                                tooltip_position: 'top'
                            },
                            {
                                name : "product_option_with_thumbnail",
                                label : "Product Option With Thumbnail",
                                required : false,
                                type: "select",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'product_option_with_thumbnail')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Product Option With Thumbnail is ON'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Product Option With Thumbnail is OFF'
                                    }
                                ],
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "msfChannelsIsEnabled",
                                label : "Enable Multi-Storefront",
                                required : false,
                                type: "select",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'msfChannelsIsEnabled')) ? 'true'  : 'false',
                                options : [
                                    {
                                        'id' : 'true',
                                        'name' : 'Enabled - Multi-Storefront is ON'
                                    },
                                    {
                                        'id' : 'false',
                                        'name' : 'Disabled - Multi-Storefront is OFF'
                                    }
                                ],
                                tooltip: 'Enable or disable Multi-Storefront on this BigCommerce Channel',
                                tooltip_position: 'top',
                                hide: cfo.hideBigCommerceMSFChannelField
                            },
                            {
                                name: "msfChannelsSelected",
                                label: "Multi-Storefront Enabled Channels",
                                type: "multiselect",
                                column : "col-md-6 mb-4 d-flex flex-column align-items-start justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'msfChannelsSelected')) ? cvs.json_options.configuration.msfChannelsSelected  : '',
                                options : (this.getNestedProperty(cvs, 'json_options', 'configuration', 'msfChannelsData')) ? cvs.json_options.configuration.msfChannelsData  : [],
                                tooltip: 'Select the multi-storefront channels to which PIM should push your products',
                                tooltip_position: 'top',
                                hide: cfo.hideBigCommerceMSFChannelField
                            }
                        ],
                    },
                    {
                        groupingName : "Store in Metafields",
                        groupItems : [
                            {
                                name : "product",
                                label : "Products",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'product')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants",
                                label : "Variants",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants_prices",
                                label : "Variants Prices",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants_prices')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants_with_attributes",
                                label : "Variants with Attributes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants_with_attributes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "variants_with_relations",
                                label : "Variants with Relations",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'variants_with_relations')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "relations",
                                label : "Relations",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'relations')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "relations_with_attributes",
                                label : "Relations with Attributes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'relations_with_attributes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            this.returnRelationsWithRelationAttributesGroupItem(cvs),
                            {
                                name : "generic_entities",
                                label : "Generic Entities",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'generic_entities')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "options",
                                label : "Options",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'options')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "prices",
                                label : "Prices",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'prices')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "inventory",
                                label : "Inventory",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'inventory')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "attributes",
                                label : "Attributes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'attributes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "barcodes",
                                label : "Barcodes",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'barcodes')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "brand",
                                label : "Brand",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'brand')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "parent",
                                label : "Parent",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'parent')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "tags",
                                label : "Tags",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'tags')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "assets",
                                label : "Assets",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'assets')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "future_exclusions",
                                label : "Future Exclusions",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'future_exclusions')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                            {
                                name : "concrete_entities",
                                label : "Concrete Entities",
                                required : false,
                                type : "checkbox",
                                column : "col-md-6 mb-4 d-flex flex-column justify-content-end",
                                value : (this.getNestedProperty(cvs, 'json_options', 'metafields', 'product_concrete_entity_relations')) ? true  : '',
                                tooltip: '',
                                tooltip_position: 'top'
                            },
                        ]
                    }
                ];
            }
        },
        mounted() {
            this.setItems();
            this.channel.items = this.addCommonSettings(this.channel.items, this.channelvalues, this.channeloptions);
        },
    };
</script>
